import React from 'react';
import TitleText from '../atoms/TitleText';
import InfoText from '../atoms/InfoText';
import { useTranslation } from 'react-i18next';
import EmptyImg from '../../assets/images/empty.png';
import EmptyDarkImg from '../../assets/images/empty-dark.png';

type Props = {
  disableDesc?: boolean;
  text?: string | React.ReactElement;
  'data-testid'?: string;
  onAdd?: () => void;
  hideButton?: boolean;
  borderless?: boolean;
};

export default function EmptyState({
  disableDesc,
  text,
  'data-testid': testId,
}: Props) {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col justify-center items-center text-center"
      data-testid={testId || 'profile-creation-empty-state'}
    >
      <img
        className="filter grayscale !w-36 md:!w-56 dark:hidden"
        src={EmptyImg}
        alt="empty state illustration"
        data-testid="profile-creation-empty-state-image"
      />
      <img
        className="filter grayscale !w-36 md:!w-56 hidden dark:block"
        src={EmptyDarkImg}
        alt="empty state illustration"
        data-testid="profile-creation-empty-state-image-dark"
      />

      <div className="empty-content md:w-3/4" data-testid="profile-creation-empty-state-content">
        <TitleText
          size="lg"
          className="font-medium text-sm md:text-lg"
          text={t('components.no_data')}
        />

        {!disableDesc ? (
          <InfoText
            text={(text as string) || t('components.no_data_description')}
            className="text-center w-full !text-[16px] !font-normal !leading-[130%] !tracking-[0px] text-[#777777] dark:text-dark-text-secondary max-w-[480px] mx-auto"
          />
        ) : (
          text
        )}
      </div>
    </div>
  );
}
